import {
  Login,
  Dashboard,
  // Orders, SortVoter, FullVoter, CastPro, BlaBle: only still used by the
  // commented-out legacy routes below (kept as reference, not deleted, per
  // the sidebar restructure's cleanup step) - re-enable these imports if
  // those routes are ever restored.
  VoterDashboard,
  VoterSearch,
  DeleteVoter,
  UploadVoter,
  AddVoter,
  AgeWiseSearch,
  AlphabeticalSearch,
  AppList,
  ChangeAppName,
  AddApp,
  UserList,
  AddUser,
  CastList,
  UploadCast,
  AddCast,
  BoothAgentList,
  AddBoothAgent,
} from "../Pages";
import { Navigate } from "react-router-dom";
import { Family } from "../Pages/Family/Family";
import { FEATURES } from "../helper";

// "Application Management" itself is only a sidebar heading/toggle (no
// content of its own, same as the other 4 dropdown modules) - its bare path
// exists only as a fallback redirect to the actual App List sub-route, so
// the two are never conflated as "the same page".
const RedirectToAppList = () => <Navigate to="/application-management/list" replace />;

// `feature` is the FEATURES key (helper/roles.config.js) ProtectRoutes checks
// via hasAccess() before rendering the route - this is what stops a role from
// opening a private page directly by URL even when the sidebar hides its link.
// A route with no `feature` is only gated on being logged in (e.g. /Family,
// which has no role-based restriction defined today).
//
// Sidebar restructure (nested dropdown modules): the routes below marked
// "interim" point at the pre-existing monolithic page components as a
// stopgap so the new nested sidebar/routes are reachable and testable end to
// end immediately - each is swapped for its real split-out page component as
// that module's split lands. The legacy flat routes (/app, /user, /fullVoter,
// /cast_pro, /bla_ble) stay in place until every new route has been verified,
// then get removed in the cleanup pass.
export const routerList = [
  {
    path: "/login",
    element: Login,
    private: 0,
  },

  {
    path: "/dashboard",
    element: Dashboard,
    key: "dashboard",
    private: 1,
    feature: FEATURES.DASHBOARD,
  },
  // Superseded by the Voter/App/User/Cast/Booth-Agent Management routes
  // below - commented out (not deleted) per the sidebar restructure's
  // cleanup step, so these old URLs now 404 instead of serving the old
  // monolithic pages. Restore by uncommenting + re-adding the matching
  // imports above if ever needed.
  // {
  //   path: "/user",
  //   element: Orders,
  //   key: "user",
  //   private: 1,
  //   feature: FEATURES.USER_MANAGEMENT,
  // },
  // {
  //   path: "/app",
  //   element: SortVoter,
  //   key: "app",
  //   private: 1,
  //   feature: FEATURES.SYSTEM_SETTINGS,
  // },
  // {
  //   path: "/fullVoter",
  //   element: FullVoter,
  //   key: "fullVoter",
  //   private: 1,
  //   feature: FEATURES.VIEW_VOTERS,
  // },
  // {
  //   path: "/cast_pro",
  //   element: CastPro,
  //   key: "cast_pro",
  //   private: 1,
  //   feature: FEATURES.CAST_PROFESSION,
  // },
  // {
  //   path: "/bla_ble",
  //   element: BlaBle,
  //   key: "bla_ble",
  //   private: 1,
  //   feature: FEATURES.BLA_BLE,
  // },
  {
    path: "/Family",
    element: Family,
    key: "family_Details",
    private: 1,
  },

  // --- Voter Management ---
  {
    path: "/voter-management/dashboard",
    element: VoterDashboard,
    key: "voter_management_dashboard",
    private: 1,
    feature: FEATURES.DASHBOARD,
  },
  {
    path: "/voter-management/search",
    element: VoterSearch,
    key: "voter_management_search",
    private: 1,
    feature: FEATURES.VOTER_SEARCH,
  },
  {
    path: "/voter-management/age-search",
    element: AgeWiseSearch,
    key: "voter_management_age_search",
    private: 1,
    feature: FEATURES.AGE_SEARCH,
  },
  {
    path: "/voter-management/alphabetical-search",
    element: AlphabeticalSearch,
    key: "voter_management_alphabetical_search",
    private: 1,
    feature: FEATURES.ALPHABETICAL_SEARCH,
  },
  {
    path: "/voter-management/delete",
    element: DeleteVoter,
    key: "voter_management_delete",
    private: 1,
    feature: FEATURES.DELETE_VOTER,
  },
  {
    path: "/voter-management/upload",
    element: UploadVoter,
    key: "voter_management_upload",
    private: 1,
    feature: FEATURES.UPLOAD_EXCEL,
  },
  {
    path: "/voter-management/add",
    element: AddVoter,
    key: "voter_management_add",
    private: 1,
    feature: FEATURES.ADD_VOTER,
  },

  // --- Application Management ---
  {
    path: "/application-management",
    element: RedirectToAppList,
    key: "application_management",
    private: 1,
    feature: FEATURES.SYSTEM_SETTINGS,
  },
  {
    path: "/application-management/list",
    element: AppList,
    key: "application_management_list",
    private: 1,
    feature: FEATURES.SYSTEM_SETTINGS,
  },
  {
    path: "/application-management/change-name",
    element: ChangeAppName,
    key: "application_management_change_name",
    private: 1,
    feature: FEATURES.SYSTEM_SETTINGS,
  },
  {
    path: "/application-management/add",
    element: AddApp,
    key: "application_management_add",
    private: 1,
    feature: FEATURES.SYSTEM_SETTINGS,
  },

  // --- User Management ---
  {
    path: "/user-management",
    element: UserList,
    key: "user_management",
    private: 1,
    feature: FEATURES.USER_MANAGEMENT,
  },
  {
    path: "/user-management/add",
    element: AddUser,
    key: "user_management_add",
    private: 1,
    feature: FEATURES.USER_MANAGEMENT,
  },

  // --- Cast Management ---
  {
    path: "/cast-management",
    element: CastList,
    key: "cast_management",
    private: 1,
    feature: FEATURES.CAST_PROFESSION,
  },
  {
    path: "/cast-management/upload",
    element: UploadCast,
    key: "cast_management_upload",
    private: 1,
    feature: FEATURES.CAST_PROFESSION,
  },
  {
    path: "/cast-management/add",
    element: AddCast,
    key: "cast_management_add",
    private: 1,
    feature: FEATURES.CAST_PROFESSION,
  },

  // --- Booth Agent Management ---
  {
    path: "/booth-agent-management",
    element: BoothAgentList,
    key: "booth_agent_management",
    private: 1,
    feature: FEATURES.BLA_BLE,
  },
  {
    path: "/booth-agent-management/add",
    element: AddBoothAgent,
    key: "booth_agent_management_add",
    private: 1,
    feature: FEATURES.BLA_BLE,
  },
];

export { ProtectRoutes } from "./ProtectRoutes";
export { PublicRoute } from "./PublicRoute";
